import type { DailyRecord } from "./types.js";

export type DailyRecordAction = { id: string; studentId: string } & (
  | { type: "answer"; delta: 1 | -1 }
  | { type: "materials"; missing: boolean }
);

export function applyDailyRecordAction(record: DailyRecord, action: DailyRecordAction): DailyRecord {
  if (
    !action.id?.trim() ||
    !action.studentId?.trim() ||
    (action.type === "answer"
      ? ![1, -1].includes(action.delta)
      : action.type !== "materials" || typeof action.missing !== "boolean")
  )
    throw new Error("invalid-daily-action");
  const applied = record.appliedActionIds ?? [];
  if (
    !Array.isArray(applied) ||
    !applied.every((id) => typeof id === "string" && !!id.trim()) ||
    new Set(applied).size !== applied.length
  )
    throw new Error("invalid-daily-actions");
  // A write may commit before its reply is lost. Explicit retry must not count that tap twice.
  if (applied.includes(action.id)) return record;
  const current = {
    ...record.students[action.studentId],
    missingMaterials: record.students[action.studentId]?.missingMaterials ?? false,
    answers: record.students[action.studentId]?.answers ?? 0,
  };
  if (!Number.isSafeInteger(current.answers) || current.answers < 0) throw new Error("invalid-answer-count");
  const student =
    action.type === "answer"
      ? { ...current, answers: Math.max(0, current.answers + action.delta) }
      : { ...current, missingMaterials: action.missing };
  return {
    ...record,
    students: { ...record.students, [action.studentId]: student },
    appliedActionIds: [...applied, action.id],
  };
}
